/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { IChallenge } from '../challenge-schema';
import { challengeSchema } from '../challenge-schema';

export const updateChallengeTitleV1ResponseSchema = createApiResponseSchema(
  challengeSchema,
) as import('zod').ZodSchema<IAPI<IChallenge>>;

export type IUpdateChallengeTitleV1Response = IAPI<IChallenge>;
